"use strict";

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withReset = void 0;

var withReset = function withReset(_ref) {
  var theme = _ref.theme;
  return {
    fontFamily: theme.typography.fonts.base,
    fontSize: theme.typography.size.s3,
    margin: 0,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    WebkitOverflowScrolling: 'touch'
  };
};

exports.withReset = withReset;


//////////////////
// WEBPACK FOOTER
// ./~/@storybook/components/dist/typography/withReset.js
// module id = 143
// module chunks = 27180705640166